import { useState, useRef } from 'react';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { color } from '../../../app/theme';
import Tag from '../../shared/Tag';
import Loading from '../../shared/Loading';

const useStyles = makeStyles(
  () => ({
    textFieldContainer: {
      cursor: 'text',
      position: 'relative',
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      minHeight: 44,
      border: `1px solid ${color.$10}`,
      borderRadius: 22,
      padding: '6px 16px 0px',
      backgroundColor: color.$7,
    },
    'textFieldContainer--focus': {
      borderColor: color.$1,
    },
    'textFieldContainer--error': {
      borderColor: color.$17,
    },
    inputContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'center',
      alignContent: 'center',
      width: '100%',
    },
    input: {
      width: '100%',
      border: 'none',
      fontSize: 15,
      lineHeight: 1,
      backgroundColor: 'transparent',
      outline: 'none',
      marginTop: -6,
      '&::placeholder': {
        color: color.$10,
      },
    },
    dropdown: {
      position: 'absolute',
      top: 'calc(100% + 4px)',
      left: 0,
      right: 0,
      zIndex: 3,
      maxHeight: 294,
      overflow: 'auto',
      backgroundColor: color.$7,
      padding: '8px 0',
      borderRadius: 12,
      boxShadow:
        '0 16px 48px 0 rgba(0, 0, 0, 0.07), 0 6px 18px 0 rgba(0, 0, 0, 0.03)',
    },
    itemContainer: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      fontSize: 13,
      lineHeight: '18px',
      padding: '13px 24px',
      '&:hover': {
        color: color.$2,
        backgroundColor: color.$19,
      },
    },
    deleteIcon: {
      cursor: 'pointer',
      position: 'absolute',
      top: '50%',
      right: 12,
      height: 24,
      transform: 'translateY(-50%)',
    },
    tag: {
      margin: '0 8px 6px 0',
      padding: '4px 8px',
      height: 'auto',
    },
    index: {
      borderRadius: 20,
      background: color.$6,
      color: color.$7,
      fontSize: '13px',
      fontWeight: '500',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: '1',
      letterSpacing: 'normal',
      textAlign: 'center',
      height: 20,
      padding: '4px 8px',
    },
  }),
  { name: 'SelectButtonTextField' },
);

const SelectButtonTextField = ({
  className,
  placeholder,
  onEnter,
  onDelete,
  menuItems,
  max,
  isLoading,
  buttons = [],
  disabled,
  allSelect,
  isError,
}) => {
  const classes = useStyles();
  const [isFocus, setIsFocus] = useState(false);
  const textFieldContainerRef = useRef(null);
  const inputRef = useRef(null);
  const buttonsIds = buttons.map(b => b?.id);
  const allSelectButtonsIds = allSelect.map(b => b?.id);
  const itemComponents = menuItems
    .filter(item => !allSelectButtonsIds.includes(item.id))
    .filter(item => !buttonsIds.includes(item.id))
    .map(item => (
      <div
        key={item.id}
        className={classes.itemContainer}
        onClick={() => {
          if (max && buttons.length >= max) {
            return;
          }
          onEnter(item);
          setIsFocus(false);
        }}
        onMouseDown={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <div className={classes.index}>{item.index}</div>
      </div>
    ));

  function handleOnFocus() {
    // setIsFocus(true);
  }

  const tagComponents = buttons.map(button => {
    const { index, id } = button || {};
    return (
      <Tag
        className={classes.tag}
        key={`auto-compeleted-text-field-${id}`}
        tag={index}
        color="colorPrimary"
        clickable
        deleteable
        isIndex
        onDeleteFunction={onDelete}
      />
    );
  });

  return (
    <ClickAwayListener onClickAway={() => setIsFocus(false)}>
      <div
        className={classnames(
          {
            [classes.textFieldContainer]: true,
            [classes['textFieldContainer--focus']]: isFocus && !disabled,
            [classes['textFieldContainer--error']]: isError && !disabled,
          },
          className,
        )}
        ref={textFieldContainerRef}
        onClick={() => {
          setIsFocus(true);
          // inputRef.current.focus();
        }}
      >
        <div className={classes.inputContainer}>
          {tagComponents}
          {!buttons.length && (
            <input
              ref={inputRef}
              className={classes.input}
              type="text"
              placeholder={placeholder}
              onFocus={handleOnFocus}
              onChange={() => {}}
              value=""
              disabled={disabled}
            />
          )}
        </div>
        {isLoading && <Loading />}
        {!disabled && !isLoading && isFocus && itemComponents.length > 0 && (
          <div className={classes.dropdown}>{itemComponents}</div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default SelectButtonTextField;
